export type FormParamValueType = string | string[] | boolean | number | null | (() => void | Promise<void>);

export type FormParams = { key: string; value: FormParamValueType }[];

export type FormValues = { [key: string]: string | string[] | boolean | number | null };

export enum FormParamKeys {
    OnFormSubmitSuccessFunction = 'onFormSubmitSuccessFunction',
}

export enum FormService {
    MarketingCloud = 'marketingcloud',
    Marketo = 'marketo',
    Workato = 'workato',
}
